import React from 'react';
import {
    RichCell,
    Button,
} from '@vkontakte/vkui';
import {
    ACCESS_DENIED_MESSAGE,
    AdaptivityContext, getSalePointsTypes, userIsTradeChild,
    isTradeDesigner,
} from "../assets/constants";

import {Icon20DeleteOutline, Icon20EditCircleFillBlue, Icon20ViewOutline} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import SalePointsApi from "../api/references/salePoints";
import BaseList from "../components/BaseList";


class MallsList extends BaseList {




    constructor(props) {


        super(props);
        this.types = getSalePointsTypes()

    }

    canCreateItem = () => {
        return !isTradeDesigner(this.props.current_user)
    }

    getItems = (mainSearch = '', append, page) => {
        clearInterval(this.searchInterval);

        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == undefined) {
            mainSearch = this.state.mainSearch
        }


        SalePointsApi.getListMalls(
            {
                isMalls: 1,
                search: mainSearch,

                page,
                epp: AdaptivityContext.isMobile ? 10 : 20
            }
        ).then((response) => {

            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })


    }


    createItem = () => {
        if (isTradeDesigner(this.props.current_user)) {
            window.postMessage({
                type: 'error',
                text: ACCESS_DENIED_MESSAGE,
                timeout: 3000
            })
            return
        }
        window.postMessage({
            type: 'setCurrentMall',
            value: {id: -1, isMall: 1}
        })
    }

    getObjectLink = (item) => {
        if (!item || item.id == null || item.id <= 0) {
            return null;
        }
        return {type: 'mall', id: item.id};
    }

    renderRow = (point, index) => {
        const isDesigner = isTradeDesigner(this.props.current_user)
        const isTradeChild = !isDesigner && userIsTradeChild(this.props.current_user, point.user_id)
        return <RichCell subhead={point.full_address} multiline
                         style={this.getRowStyle(point)}
                         caption={
                             <span>Автор: <b>{point.author_name}</b> Изменено: {point.modified}</span>}
                         afterCaption={<div style={{
                             display: "flex",
                             flexDirection: "column"
                         }}>
                             <Button mode="secondary"
                                     onClick={() => {
                                         this.setLastOpenedItem(point.id);
                                         window.postMessage({
                                             type: 'setCurrentMall',
                                             value: point
                                         });
                                     }}
                                     size="s">{isTradeChild ?
                                 <Icon20EditCircleFillBlue/> :
                                 <Icon20ViewOutline/>}</Button>
                             {isTradeChild && <Button mode="secondary"
                                                      onClick={() => this.setState({
                                                          delete_id: point.id,
                                                          showDeleteSalePointAlert: true
                                                      })}
                                                      size="s"><Icon20DeleteOutline/></Button>}
                         </div>
                         }
        >

            {this.types[point.type_]} {point.title}
        </RichCell>
    }

}

export default MallsList